import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Cart.css";

const Cart = ({ cart, setCart }) => {
  const navigate = useNavigate();

  const calculateSubtotal = () => {
    return cart
      .reduce((sum, item) => sum + item.price * item.quantity, 0)
      .toFixed(2);
  };

  const handleProceedToCheckout = () => {
    navigate("/checkout/step1", { state: { cart } });
  };

  const handleRemoveItem = (indexToRemove) => {
    const updatedCart = cart.filter((_, index) => index !== indexToRemove);
    setCart(updatedCart);
  };

  const handleQuantityChange = (index, newQuantity) => {
    const updatedCart = cart.map((item, i) =>
      i === index ? { ...item, quantity: newQuantity } : item
    );
    setCart(updatedCart.filter((item) => item.quantity > 0));
  };

  if (!cart || cart.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-container">
          <h2 className="cart-title">Your Cart</h2>
          <p className="empty-cart-message">Your cart is empty.</p>
          <p className="return-link">
            <Link to="/products">Return to Products</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        <h2 className="cart-title">Your Cart</h2>
        <div className="cart-items">
          {cart.map((item, index) => (
            <div key={index} className="cart-item">
              <img
                src={item.image}
                alt={item.title}
                className="cart-item-image"
              />
              <div className="cart-item-details">
                <p>{item.title}</p>
                <p>Price: ${item.price.toFixed(2)}</p>
                <div className="quantity-control">
                  <label htmlFor={`quantity-${index}`}>Quantity:</label>
                  <select
                    id={`quantity-${index}`}
                    value={item.quantity}
                    onChange={(e) =>
                      handleQuantityChange(index, parseInt(e.target.value))
                    }
                  >
                    {[...Array(Math.max(5, item.quantity + 1)).keys()].map(
                      (qty) => (
                        <option key={qty} value={qty}>
                          {qty === 0 ? "Remove" : qty}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
              <button
                className="remove-button"
                onClick={() => handleRemoveItem(index)}
                aria-label={`Remove ${item.title} from cart`}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
        <div className="cart-summary">
          <p className="summary-label">Subtotal:</p>
          <p className="summary-value">${calculateSubtotal()}</p>
        </div>
        <div className="button-container">
          <button className="checkout-button" onClick={handleProceedToCheckout}>
            Proceed to Checkout
          </button>
          <p className="return-link below-button">
            <Link to="/products">Return to Products</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cart;
